import { Injectable } from '@angular/core';
import { HammerGestureConfig } from '@angular/platform-browser';

import { DIRECTION_HORIZONTAL, TouchMouseInput } from 'hammerjs';

// https://stackoverflow.com/questions/41017202/vertical-scroll-is-not-working-with-hammerjs-and-angular2
@Injectable({ providedIn: 'root' })
export class HammerGestureConfigProvider extends HammerGestureConfig {
    override overrides = {
        pinch: { enable: false },
        rotate: { enable: false },
        swipe: {
            direction: DIRECTION_HORIZONTAL,
        },
    };

    // https://github.com/hammerjs/hammer.js/issues/1240
    override options = {
        inputClass: TouchMouseInput,
    };
}
